module.exports = "images/homepage.2701d6e1.png";